{
  "name": "front",
  "version": "1.44.19",
  "scripts": {
    "ng": "ng",
    "prestart": "node scripts/gen-env-js.js user",
    "start": "ng serve user-portal --configuration=dev",
    "preuser": "node scripts/gen-env-js.js user",
    "preadmin": "node scripts/gen-env-js.js admin",
    "admin": "ng serve admin-portal --configuration=dev --port=4201",
    "prenpx-admin": "node scripts/gen-env-js.js admin",
    "npx-admin": "npx ng serve admin-portal --configuration=dev --host 127.0.0.1 --port=4201",
    "prenpx-user": "node scripts/gen-env-js.js user",
    "npx-user": "npx ng serve user-portal --configuration=dev --host 127.0.0.1 --port=4200",
    "user": "ng serve user-portal --configuration=dev",
    "build": "ng build",
    "build:user": "ng build user-portal",
    "build:admin": "ng build admin-portal",
    "typecheck": "npm run typecheck:user && npm run typecheck:admin && npm run typecheck:common",
    "typecheck:user": "ngc --noEmit -p projects/user-portal/tsconfig.app.json && ngc --noEmit -p projects/user-portal/tsconfig.spec.json",
    "typecheck:admin": "ngc --noEmit -p projects/admin-portal/tsconfig.app.json && ngc --noEmit -p projects/admin-portal/tsconfig.spec.json",
    "typecheck:common": "ngc --noEmit -p projects/common-module/tsconfig.typecheck.json && ngc --noEmit -p projects/common-module/tsconfig.spec.json",
    "i18n:check": "node scripts/i18n-check.js",
    "verify": "npm run typecheck && npm run i18n:check && npm run test:all",
    "test": "npm run test:all",
    "test:all": "npm run test:user && npm run test:admin && npm run test:common",
    "test:user": "ng test user-portal --watch=false --browsers=ChromeHeadless",
    "test:admin": "ng test admin-portal --watch=false --browsers=ChromeHeadless",
    "test:common": "ng test common-module --watch=false --browsers=ChromeHeadless",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "engines": {
    "node": "^20.11.1 || ^22.0.0"
  },
  "dependencies": {
    "@angular/animations": "19.2.17",
    "@angular/cdk": "19.2.17",
    "@angular/common": "19.2.17",
    "@angular/compiler": "19.2.17",
    "@angular/core": "19.2.17",
    "@angular/forms": "19.2.17",
    "@angular/material": "19.2.17",
    "@angular/platform-browser": "19.2.17",
    "@angular/platform-browser-dynamic": "19.2.17",
    "@angular/router": "19.2.17",
    "@js-joda/core": "^5.5.3",
    "@js-joda/timezone": "^2.21.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@types/file-saver": "^2.0.1",
    "@types/geojson": "^7946.0.14",
    "@types/jspdf": "^1.3.3",
    "@types/ol": "^6.4.2",
    "@videogular/ngx-videogular": "^10.0.0",
    "angular-split": "^17.1.1",
    "aur-openlayers": "^19.7.0",
    "core-js": "^3.36.1",
    "echarts": "5.1.2",
    "file-saver": "^2.0.2",
    "hls.js": "^0.14.17",
    "html2canvas": "^1.4.1",
    "jspdf": "^2.3.1",
    "keycloak-angular": "^19.0.2",
    "keycloak-js": "^24.0.4",
    "ng-qrcode": "^19.0.1",
    "ngx-mask": "17.0.7",
    "ngx-mat-select-search": "^7.0.6",
    "ol": "6.5.0",
    "ol-ext": "^3.1.19",
    "pepjs": "^0.5.3",
    "proj4": "2.6.0",
    "rxjs": "7.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.19",
    "@angular-eslint/builder": "16.3.1",
    "@angular-eslint/eslint-plugin": "16.3.1",
    "@angular-eslint/eslint-plugin-template": "15.2.1",
    "@angular-eslint/schematics": "18.3.0",
    "@angular-eslint/template-parser": "15.2.1",
    "@angular/cli": "19.2.19",
    "@angular/compiler-cli": "19.2.17",
    "@angular/language-service": "19.2.17",
    "@babel/core": "^7.13.0",
    "@types/core-js": "^2.5.4",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "^2.0.6",
    "@types/node": "~12.0.4",
    "@typescript-eslint/eslint-plugin": "^4.26.1",
    "@typescript-eslint/parser": "^4.26.1",
    "eslint": "^7.28.0",
    "eslint-plugin-import": "latest",
    "eslint-plugin-jsdoc": "latest",
    "eslint-plugin-prefer-arrow": "latest",
    "jasmine-core": "~3.8.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.3.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "^2.0.5",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "ngx-aur-mat-dialog": "19.0.2",
    "ngx-aur-mat-table": "19.18.1",
    "parcel-bundler": "^1.9.4",
    "postcss": "^8.3.3",
    "protractor": "^7.0.0",
    "ts-node": "~8.2.0",
    "typescript": "5.8.3"
  }
}
